const setItem = (key, value) => {
	if (isAccessable()) {
		localStorage.setItem(key, value)
	}
}
const getItem = key => {
	if (isAccessable()) {
		return localStorage.getItem(key)
	}
}

const isAccessable = () => {
	try {
		localStorage.setItem("__", "")
		return true
	} catch {
		return false
	}
}
const removeItem = key => {
	if (isAccessable()) {
		localStorage.removeItem(key)
	}
}

const localStore = {
	setItem,
	isAccessable,
	getItem,
	removeItem,
}
export default localStore
